import React from 'react';

const createReactClass = require('create-react-class');

let currentAdCount = 0;
const uniquePlacementApiKeys = ['NC4hUkTKcXSBBb55vjzDHp4P', '1g966Cc46p2DkoDbTquvdFS1', 'GaJUA37jxakA8rQU1K4xbEdP'];

const AdResultCard = createReactClass({
  getInitialState() {
    currentAdCount += 1;
    const adUnitName = `div-gpt-ad-1551826656348-${currentAdCount}`;
    let placementApiKey = 'Q1tHrwHQjqvjUg8PYTSLXMyj';
    if (currentAdCount <= 3) {
      placementApiKey = uniquePlacementApiKeys[currentAdCount - 1];
    }
    return { adUnitName, placementApiKey };
  },
  componentDidMount() {
    if (this.props.renderSFPAd) {
      // Default ad sizes since its served by sharethrough
      const adSizes = [[1, 1]];
      googletag.cmd.push(
        function() {
          const currentSlot = googletag
            .defineSlot(this.props.slotName, adSizes, this.state.adUnitName)
            .setTargeting('state', [])
            .setTargeting('Pro', ['0', '1'])
            .setTargeting('Member', ['0', '1'])
            .setTargeting('strnativekey', this.state.placementApiKey)
            .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
          googletag.pubads().refresh([currentSlot]);
          googletag.display(this.state.adUnitName);
          this.setState({ currentAdSlot: currentSlot });
        }.bind(this)
      );
    } else {
      googletag.cmd.push(
        function() {
          const currentSlot = googletag
            .defineSlot(this.props.slotName, this.props.adSizes, this.state.adUnitName)
            .addService(googletag.pubads())
            .setCollapseEmptyDiv(true);
          googletag.pubads().setTargeting('position', [currentAdCount]);
          Object.keys(this.props.adTargetingHash).forEach(
            function(key) {
              if (this.props.adTargetingHash[key]) googletag.pubads().setTargeting(key, [this.props.adTargetingHash[key]]);
            }.bind(this)
          );
          googletag.pubads().setTargeting('Member', ['0', '1']);
          googletag.pubads().disableInitialLoad();
          this.setState({ currentAdSlot: currentSlot });
          googletag.display(this.state.adUnitName);
        }.bind(this)
      );
    }
  },
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.refreshAd) return true;
    return false;
  },
  componentDidUpdate() {
    if (this.props.refreshAd) {
      // googletag.cmd.push(function() {
      //   googletag.pubads().refresh([this.state.currentAdSlot]);
      // }.bind(this));
    }
  },
  componentWillUnmount() {
    googletag.cmd.push(
      function() {
        googletag.destroySlots([this.state.currentAdSlot]);
      }.bind(this)
    );
  },
  render() {
    // Need to do this double div so react can manage the presence of the ad result card
    // While DFP manages the ad unit in the inner div
    let adClasses = 'ad-result-card';
    adClasses += this.props.renderSFPAd ? ' sfp' : ' dfp';

    const adCustomStyle = this.props.renderSFPAd ? { width: 1, height: 1 } : {};
    return (
      <div id={`sharethrough-unit-${currentAdCount}`} className={adClasses}>
        <div id={this.state.adUnitName} style={adCustomStyle} className="holder" />
      </div>
    );
  }
});

AdResultCard.defaultProps = {
  renderSFPAd: false,
  adTargetingHash: {},
  slotName: '/4689141/alltrails_trail_300x250_top',
  adSizes: ['fluid', [300, 250]]
};

export { AdResultCard };
